<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details" (changeEvent)="onMenuItemClick($event)">
        <div class="detail-page-action-bar">
            @if (permissions.canEdit) {
                <button class="btn btn-cerrix" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span data-uiid="save" class="d-none d-lg-inline">Save step</span>
                </button>
            }

            @if (stepModel.useReviewWorkflow) {
                <div class="workflow-area">
                    <span class="workflow-description">
                        Workflow Status |
                        <b>{{
                            stepModel.useReviewWorkflow && stepModel.workflow.statusDescription
                                ? stepModel.workflow.statusDescription
                                : "New"
                        }}</b>
                        <i
                            class="far fa-question-circle mx-2"
                            [matTooltip]="
                                stepModel.workflow && stepModel.workflow.statusDescription
                                    ? stepModel.workflow.statusDescription
                                    : ''
                            "
                        ></i>
                    </span>
                    @if (nextStatus) {
                        <button
                            type="button"
                            (click)="newCommentDialog($event, true)"
                            class="btn btn-success"
                            id="positive"
                        >
                            {{ nextStatus }}
                        </button>
                    }
                    @if (backStatus) {
                        <button
                            (click)="newCommentDialog($event, false)"
                            class="btn btn-danger"
                            id="negative"
                        >
                            {{ backStatus }}
                        </button>
                    }
                </div>
            }
        </div>

        <div
            name="Fieldwork step"
            menuItemId="fieldwork-step"
            menuicon="fas fa-step-forward"
            menusystemsubmenu
        >
            <div
                name="Details"
                menuItemId="fieldwork-step-details"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <audit-fieldwork-step-detail-main
                    [auditGuid]="auditGuid"
                    [permissions]="permissions"
                    [stepModel]="stepModel"
                ></audit-fieldwork-step-detail-main>

                @if (permissions.canViewLinkedFindings) {
                    <audit-fieldwork-step-finding-linking
                        [auditGuid]="auditGuid"
                        [stepGuid]="stepModel.guid"
                        [permissions]="permissions"
                        [linkedFindings]="stepModel.findings"
                    ></audit-fieldwork-step-finding-linking>
                }
            </div>
            <div
                name="Links"
                menuItemId="fieldwork-step-links"
                menuicon="fas fa-link"
                menusystemsubmenu
            >
                @if (permissions.canViewLinkedRisks) {
                    <div
                        name="Risks"
                        menuItemId="fieldwork-step-risks"
                        menuicon="fad fa-exclamation-triangle"
                        menusystemitem
                    >
                        <audit-fieldwork-step-risk-linking
                            [auditGuid]="auditGuid"
                            [stepGuid]="stepModel.guid"
                            [permissions]="permissions"
                            [linkedRisks]="stepModel.risks"
                        ></audit-fieldwork-step-risk-linking>
                    </div>
                }
                @if (permissions.canViewLinkedControls) {
                    <div
                        name="Controls"
                        menuItemId="fieldwork-step-controls"
                        menuicon="fad fa-shield-alt"
                        menusystemitem
                    >
                        <audit-fieldwork-step-control-linking
                            [auditGuid]="auditGuid"
                            [stepGuid]="stepModel.guid"
                            [permissions]="permissions"
                            [linkedControls]="stepModel.controls"
                        ></audit-fieldwork-step-control-linking>
                    </div>
                }
                @if (permissions.canViewLinkedDocuments) {
                    <div
                        name="Documents"
                        [attr.menuItemId]="documentTabId"
                        menuicon="far fa-file"
                        menusystemitem
                    >
                        <audit-fieldwork-step-document-linking
                            [auditGuid]="auditGuid"
                            [permissions]="permissions"
                            [linkedDocuments]="stepModel.documents"
                        ></audit-fieldwork-step-document-linking>
                    </div>
                }
                @if (stepModel.id > 0) {
                    <div
                        menuItemId="history"
                        name="History"
                        menusystemitem
                        menuicon="fas fa-history"
                    >
                        <app-history-overview
                            [historyDataService]="_ds"
                            [Id]="stepModel.guid"
                            [ExtraParam]="auditGuid"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                }
            </div>
        </div>
    </div>
}
